// Generated by scripts/icons/build-icon-components.mjs from the matching
// file in ./svg — edit the SVG and re-run the script, not this file.
import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

const RoleReviewerIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <g fill="currentColor">
      <path
        d="M4.53 21.01h10.13c1.72 0 2.94-1.15 3.03-2.88.02-4.25-6.08-4.3-8.1-4.32-2.01.01-8.1.06-8.09 4.34C1.58 19.86 2.8 21 4.53 21"
        opacity=".5"
      />
      <path d="M5.24 7.35c0 2.4 1.96 4.35 4.36 4.35s4.36-1.95 4.36-4.35S12 2.99 9.6 2.99 5.24 4.94 5.24 7.35M18.2 12.2q-.44 0-.75-.3l-1.56-1.57c-.42-.42-.42-1.1 0-1.52s1.1-.42 1.52 0l.8.8 2.45-2.46c.42-.42 1.1-.42 1.52 0 .43.42.43 1.1 0 1.53l-3.21 3.21q-.32.31-.76.32" />
    </g>
  </SvgIcon>
);

export default RoleReviewerIcon;
